import {DefaultTheme, createGlobalStyle} from 'styled-components';
import BossaBold from '../assets/webfonts/Bossa-Bold.woff';
import BossaBold2 from '../assets/webfonts/Bossa-Bold.woff2';
import BossaExpandedBold from '../assets/webfonts/Bossa-ExpandedBold.woff';
import BossaExpandedBold2 from '../assets/webfonts/Bossa-ExpandedBold.woff2';

declare module 'styled-components' {
  export interface DefaultTheme {
    colors: {
      white: string;
      red: string;
      dark950: string;
      dark900: string;
      dark800: string;
      violet500: string;
      violet300: string;
      violet200: string;
      violet100: string;
      orange600: string;
      orange500: string;
      orange100: string;
      gray300: string;
      gray200: string;
      gray100: string;
    };
    sizes: {
      mw: string;
      mwInner: string;
    };
    breakpoints: {
      landscape: string;
      tablet: string;
      phone: string;
    };
  }
}

const myTheme: DefaultTheme = {
  colors: {
    white: '#ffffff',
    red: '#D85D6B',
    dark950: '#2f2a3e',
    dark900: '#342e49',
    dark800: '#514c62',
    violet500: '#360bc9',
    violet300: '#7247ff',
    violet200: '#edeafb',
    violet100: '#f8f7fd',
    orange600: '#eb5530',
    orange500: '#ff6944',
    orange100: '#fef7f1',
    gray300: '#d6d5dd',
    gray200: '#F4F4F4',
    gray100: '#fcfcfc',
  },
  sizes: {
    mw: '1440px',
    mwInner: '1100px',
  },
  breakpoints: {
    landscape: ' (max-width: 1024px)',
    tablet: ' (max-width: 768px)',
    phone: ' (max-width: 640px)',
  },
};

export default myTheme;

export const GlobalStyle = createGlobalStyle`
  @font-face {
    font-family: 'Bossa Bold';
    src: url(${BossaBold2}) format('woff2'),
        url(${BossaBold}) format('woff');
    font-weight: bold;
    font-style: normal;
    font-display: swap;
  }
  @font-face {
    font-family: 'Bossa Bold Expanded';
    src: url(${BossaExpandedBold2}) format('woff2'),
        url(${BossaExpandedBold}) format('woff');
    font-weight: bold;
    font-style: normal;
    font-display: swap;
  }
  *, ::after, ::before {
      box-sizing: border-box;
      margin: 0;
  }
  html,
  body {
    height: 100%;
    margin: 0;
  }
  body {
    padding: 0;
    font-family: 'Mulish', sans-serif;
    font-weight: 300;
    color: ${(props) => props.theme.colors.dark800};
    font-size: 16px;
    line-height: 1.2;

    &.noscroll {
      overflow: hidden;
    }
  }
  #root {
    min-height: 100%;
  }
  a {
    color: inherit;
  }
  p {
    font-size: 1.3rem;
    line-height: 1.5;
  }
  h1, h2, h3, h4, h5 {
    font-family: 'Bossa Bold', sans-serif;
  }
`;
